// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__IC5ee","bigColWidth":"Table_bigColWidth__3x6fx","biggerColWidth":"Table_biggerColWidth__3v3BZ","row":"Table_row__2mbdz","col":"Table_col__2GtTe"};